export default "https://cdn-static.gokick.com/assets/f56d8541e187cf36c438a68224daa166420c5eb6/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";